const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/; // eslint-disable-line

const validate = (values: any) => {
  const errors: any = {};

  if (!values.firstName) {
    errors.firstName = 'Обязательное поле';
  }

  if (!values.secondName) {
    errors.secondName = 'Обязательное поле';
  }

  if (!values.email) {
    errors.email = 'Обязательное поле';
  } else if (!emailPattern.test(values.email.toLowerCase())) {
    errors.email = 'Неверный формат электронной почты';
  }

  return errors;
};

export default validate;
